// extracted by mini-css-extract-plugin
export default {"layout":"Home_layout__1Mfu5","title":"Home_title__aKtE3"};